import { computed, toValue } from "vue";
import { matchesSearchTerm } from "@/common/helpers/search";
export const contentMatchesSearchTerm = (content, term) => matchesSearchTerm(content.displayName, term);
// In-flight uploads carry the name at the top level; saved rows carry it on `content`.
const itemMatches = (item, term) => item.uploading ? matchesSearchTerm(item.displayName, term) : contentMatchesSearchTerm(item.content, term);
// Client-side display-name filter over the already-loaded file set (no server round-trip).
export const useFileNameFilter = (items, query) => {
    const filteredItems = computed(() => {
        const term = toValue(query).trim();
        const all = toValue(items);
        if (!term)
            return all;
        return all.filter((item) => itemMatches(item, term));
    });
    return { filteredItems };
};
